export default __webpack_public_path__ + "static/media/pictogramBeaconEarthHeart64.be86fe89.svg";